module.exports = __webpack_public_path__ + "img/crpt.92521c34.svg";